<script setup>
import { computed } from 'vue'

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	label: {
		type: String,
		required: false,
	},
	/* Compact */
	compact: {
		type: Boolean,
		default: false,
	},
})

const frameClass = computed(() => (props.compact ? 'inline-flex h-6 rounded-md text-[11px]' : 'flex h-7 text-xs @xl:rounded-lg'))

const titleClass = computed(() => (props.compact ? 'flex-none pl-2 pr-4' : 'flex-1 px-2 @xl:flex-none @xl:px-4'))
const labelClass = computed(() => (props.compact ? 'flex-none pr-2 pl-0' : 'flex-1 px-2 @xl:basis-auto @xl:px-4'))

/* Cap alignment */
const textClass = 'pt-0.5'
</script>

<template>
	<div :class="['font-poppins relative overflow-hidden bg-linear-to-r from-[#e0b138] to-[#f88e37] leading-none font-semibold uppercase', frameClass]">
		<div :class="['relative flex min-w-0 items-center justify-center', titleClass]">
			<div :class="['min-w-0 truncate text-white text-shadow-[0_1px_2px_rgba(0,0,0,0.4)]', textClass]">{{ title }}</div>
		</div>
		<div :class="['relative flex min-w-0 items-center justify-center', labelClass]" v-if="label">
			<div class="absolute inset-y-0 -right-8 -left-2 -skew-x-25 bg-[#fbfcfd] mix-blend-overlay"></div>
			<div :class="['text-snk-dark-500 relative min-w-0 truncate', textClass]">{{ label }}</div>
		</div>
	</div>
</template>
